import addHours from 'date-fns/addHours';
import addMinutes from 'date-fns/addMinutes';
import addSeconds from 'date-fns/addSeconds';
import EventManager from 'services/timer/event-manager';
import Timer, { withEvents } from 'services/timer/timer';

class CountDownTimer extends Timer {
  constructor(config) {
    const { duration } = config || { duration: '00:00:00' };
    super(config);
    this.duration = duration;
    this.timerStates.completed = 'COMPLETED';
  }
  getDateFromDuration(date, duration) {
    if(typeof duration !== 'string' || !(date instanceof Date)) {
      throw Error('getDateFromDuration: duration must be string and needs a Date object.');
    }
    const [hours, minutes, seconds] = duration.split(':').map(v => parseInt(v, 10));
    return addSeconds(addMinutes(addHours(date, hours || 0), minutes || 0), seconds || 0);
  }
  getTimeLeftInMillisec() {
    const now = new Date();
    const durationDate = this.getDateFromDuration(now, this.duration).getTime();
    const currentTimeDate = addSeconds(now, this.time).getTime();
    return durationDate - currentTimeDate;
  }
  tick() {
    if(this.getCurrentState() === this.timerStates.completed) {
      return;
    }
    this.timeLeft = this.getTimeLeftInMillisec() / 1000;
    if(this.timeLeft <= 0) {
      this.stop();
      this.setState(this.timerStates.completed);
    }
    super.tick();
  }
}

class CountDownTimerWithEvents extends CountDownTimer {
  constructor(config) {
    const { eventPrefix = 'countdownTimer' } = config;
    super(config);
    withEvents.bind(this)(new EventManager(eventPrefix));
  }
}

export { CountDownTimer, CountDownTimerWithEvents };
